import React, { useEffect } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import { Button } from "../ui/button";
import { getPrintLocationUsageById } from "../../api/admin/print-locations";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import Loader from "../common/loader/loader";

const DeletePrintLocationDialog = ({
  open,
  onClose,
  printLocation,
  onPrintLocationDelete,
}: any) => {
  const [loading, setLoading] = React.useState<any>(true);

  const [usage, setUsage] = React.useState<any | null | false>(null);
  const [loadingUsageError, setLoadingUsageError] = React.useState<any>(null);

  const loadPrintLocationUsage = async (printLocationId: string) => {
    const response = await getPrintLocationUsageById(printLocationId);
    console.log("response", response);

    if (!response) {
      setLoadingUsageError("Error loading print location usage data.");
      setLoading(false);
      return;
    }

    if (response && response.data) {
      setLoadingUsageError(null);
      setUsage(response.data);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (printLocation?._id) {
      loadPrintLocationUsage(printLocation?._id);
    }

    return () => {
      setUsage(null);
      setLoadingUsageError(null);
      setLoading(true);
    };
  }, [printLocation?._id]);

  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-[rgba(0,0,0,.6)] data-[state=open]:animate-overlayShow fixed inset-0" />

        <Dialog.Content className="data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[90vh] w-full max-w-[60vw] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-blackLight p-[25px] shadow-[hsl(206, 22%, 93%) 0px 10px 38px -10px, hsl(206, 22%, 93%) 0px 10px 20px -15px] focus:outline-none text-body">
          <Dialog.Title className="text-mauve12 m-0 text-[17px] font-medium">
            Delete Print Location
          </Dialog.Title>

          <div className="my-8 flex flex-col items-center justify-center">
            {loading && !loadingUsageError && <Loader />}

            {!loading && loadingUsageError && (
              <div className="text-red-500">{loadingUsageError}</div>
            )}

            {!loading &&
              !loadingUsageError &&
              usage &&
              (usage?.templates.length > 0 || usage?.sets.length > 0) && (
                <div className="w-full h-full flex flex-col items-start gap-x-2 border-t border-borderColor pt-2">
                  This Print Location is being used in:{" "}
                  <ScrollArea.Root className="mt-2 w-full relative h-[100px] overflow-hidden">
                    <ScrollArea.Viewport className="w-full h-full py-2 px-2 relative rounded bg-borderColor">
                      {usage?.templates && (
                        <div className=" flex flex-col font-bold my-2">
                          Templates:
                          {usage?.templates.map((template: any) => (
                            <span key={template._id} className="text-primary">
                              {template.slug}
                            </span>
                          ))}
                        </div>
                      )}
                      {usage?.sets && (
                        <div className=" flex flex-col font-bold my-2">
                          Sets:
                          {usage?.sets.map((set: any) => (
                            <span key={set.slug} className="text-primary">
                              {set.slug}
                            </span>
                          ))}
                        </div>
                      )}
                    </ScrollArea.Viewport>
                    <ScrollArea.Scrollbar
                      className="flex select-none touch-none p-0.5 transition-colors duration-[160ms] ease-out hover:bg-black data-[orientation=vertical]:w-2.5"
                      orientation="vertical"
                    >
                      <ScrollArea.Thumb className="flex-1 bg-scrollbarColor rounded-[10px]" />
                    </ScrollArea.Scrollbar>
                  </ScrollArea.Root>
                </div>
              )}

            {!loading &&
              !loadingUsageError &&
              (!usage ||
                (usage && !usage?.templates.length && !usage?.sets.length)) && (
                <div className="w-full h-full  flex flex-col items-start gap-x-2 border-t border-borderColor pt-2">
                  This Print Location is not being used in any Templates or
                  Sets.
                  <div>
                    Are you sure you want to delete the Print Location{" "}
                    <span className="font-bold">
                      {printLocation?.internalName}
                    </span>
                    ?
                  </div>
                </div>
              )}
          </div>

          <div className="py-2 h-full w-full flex items-end gap-x-2 justify-end ">
            <Button onClick={() => onClose()}>Cancel</Button>
            <Button
              onClick={() => onPrintLocationDelete(printLocation?._id)}
              disabled={
                loading ||
                loadingUsageError ||
                (usage && usage?.templates.length > 0) ||
                (usage && usage?.sets.length > 0)
              }
              className="bg-red-500 hover:bg-red-600"
            >
              Delete
            </Button>
          </div>

          <Dialog.Close asChild>
            <button
              className="text-white hover:text-primary focus:shadow-violet7 absolute top-[10px] right-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
              aria-label="Close"
            >
              <Cross2Icon />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default DeletePrintLocationDialog;
